import { HttpBackend, HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApiLinks } from '@cutting/app.api-links';
import { CuttingClient, User } from 'cloud-shared-lib';
import { Observable } from 'rxjs';

export interface IUserResponse {
  managersDTO: User[];
  totalCount: number;
}

@Injectable({ providedIn: 'root' })
export class UserService {
  private httpLocal: HttpClient;

  constructor(private http: HttpClient, private handler: HttpBackend) {
    this.httpLocal = new HttpClient(this.handler);
  }

  getClientExtended(): Observable<CuttingClient> {
    return this.http.get<CuttingClient>(ApiLinks.clientExtended);
  }

  saveClient(client: CuttingClient): Observable<CuttingClient> {
    return this.http.put<CuttingClient>(ApiLinks.clientExtended, client);
  }

  setNewPassword(newPassword: string, oldPassword: string): Observable<boolean> {
    const httpParams: HttpParams = new HttpParams().set('newPassword', newPassword).set('oldPassword', oldPassword);

    return this.http.put<boolean>(ApiLinks.changePassword, undefined, { params: httpParams });
  }

  changeEmail(key: string): Observable<void> {
    const httpParams: HttpParams = new HttpParams().set('key', key);

    return this.httpLocal.post<void>(ApiLinks.setNewEmail, undefined, { params: httpParams });
  }

  sendChangeEmailMess(newEmail: string): Observable<void> {
    return this.http.post<void>(ApiLinks.sendChangeEmailMess, { newEmail });
  }

  deleteAccount(clientId: number): Observable<void> {
    return this.http.delete<void>(`${ApiLinks.deleteAccount}/${clientId}`);
  }
}
